import React, { useState } from 'react'
import Table from '../../../../components/Common/Table'
import TableNoRecords from '../../../../components/Common/Table/TableNoRecords'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import tableColumns, { columnsForBOB } from '../tableColumns';
import '../style.css'
import LenderUgroService from '../../../../services/lender';
import { Context } from '../../../../config/store';
import Pagination from '../../../../components/Pagination';
import Modal from '../../../../components/Modal';
import ReactTooltip from 'react-tooltip';
import { toast } from 'react-toastify';
import { downloadFile } from '../../../../common/download';
import DatePicker from 'react-datepicker';
import { getFormattedDate } from '../../../../common/date';
import Button from "../../../../components/Common/Button";

const View = ({ item }) => {
  const { state } = React.useContext(Context);
  const navigate = useNavigate();
  const [modalState, setModalState] = React.useState(false)
  const [loading, setLoading] = useState(false)
  const StatusLog = item?.lender_application_status?.ApplicationStatus?.length > 0 ? item?.lender_application_status?.ApplicationStatus : []
  const [status, setStatus] = useState([])
  const [showTooltip, setShowTooltip] = React.useState(false)

  React.useLayoutEffect(() => {
    setStatus(StatusLog)
  }, [item.id])

  const StatusCheck = async (ele) => {
    setLoading(true)
    let response = await LenderUgroService.getStatusApilogs({
      type: state.userType,
      cl_lead_id: ele.cl_lead_id,
      cl_lender_id: ele.cl_lender_id,
    });

    if (response?.status === 200) {
      setLoading(false)
      if (response?.data?.data?.log) {
        setStatus(response?.data?.data?.log?.ApplicationStatus)
        toast.success(response?.data?.data?.log?.Message)
      } else {
        setStatus([])
      }
    } else {
      toast("Some error occoured")
    }
  }
  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };
  return (
    <div className='row m-auto justify-content-around'>
      {checkHasPermission('view-logs') && <>
        <button
          className='btn btn-custom viewBtn'
          onClick={(e) => {
            navigate(`/api-logs/${item?.cl_lead_id}/${item?.cl_lender_id}/${item?.lead_type}`)
            e.preventDefault();
          }}
          data-tip
          data-for='view-logs'
        >
          <i className='fa fa-eye'></i>
        </button>
        <ReactTooltip id='view-logs'>View Logs</ReactTooltip>
      </>}
      {checkHasPermission('logs-view-status') && <>
        <button
          className='btn btn-custom viewBtn'
          onClick={(e) => {
            setTimeout(() => setShowTooltip(false), 50);
            setModalState(true)
          }}
          data-tip
          data-for='view-status'
          onMouseEnter={() => {
            setShowTooltip(true)
          }}
          onMouseLeave={() => {
            setShowTooltip(false);
          }}
        >
          <i className='fa fa-info-circle'></i>
        </button>
        {showTooltip && <ReactTooltip id='view-status'>View status</ReactTooltip>}
      </>}
      <Modal
        style={{
          minWidth: "20%",
          padding: "0px",
          backgroundColor: "transparent",
          width: '450px',
          minHeight: '100px'
        }}
        removeBorderSpace={true}
        state={modalState}
        closeModal={() => { setModalState(!modalState) }}
      >
        <div className='logs_status'>
          <div className='card border-0'>
            <div className="modal-header-container">
              <div className="modal-title">Application Status</div>
              <div className="closeModalView" onClick={() => { setModalState(!modalState) }}>
                <span className="closeModalIcon">x</span>
              </div>
            </div>
            <div className='row'>
              <div className='col-10'>
                <div className=" p-3 statusList">
                  {status.length > 0 ?
                    status?.map((status) => {
                      return (
                        <p>{status}</p>
                      )
                    })
                    :
                    <p className='text-center'>No status found</p>
                  }
                </div>
              </div>
              <div className='col-2'>
                <div className='d-flex justify-content-end m-2'>
                  {checkHasPermission('logs-fetch-status') && <button
                    className='btn btn-custom viewBtn'
                    onClick={() => StatusCheck(item)}
                    disabled={loading}
                  >
                    {loading ? <div className='loader'></div> : "Fetch Status From lender"}
                  </button>}
                </div>
              </div>
            </div>


          </div>
        </div>
      </Modal>
    </div>
  )
}

const LenderNames =
{
  '2': "IDBI",
  '3': "CBI",
  '4': "BOB",
  '1': "SBI",
  '13': "Godrej",
  '15': "UCO",
  '16': "KVB",
  '18': "Hero Housing",
  '19': "SIDBI",
  '20': "Karnataka",
  '23': "BOM",
  '22': "ABCL",
}

let isOutside = false;

const ApiListing = () => {

  const location = useLocation();
  let searchData = JSON.parse(sessionStorage.getItem('searchData'));
  const getParamsFromSessionStorage = (key, type = null) => {
    let searchDataResult = searchData ? searchData[key] : '';
    if (type === 'date' && searchDataResult) {
      let convertedDate = searchDataResult?.split('/')
      return new Date(`${convertedDate[1]}/${convertedDate[0]}/${convertedDate[2]}`)
    }
    return searchDataResult;

  }

  let sessionStorageData = searchData || {};
  let { org_page = 1 } = sessionStorageData;
  const [page, setCurrentPage] = React.useState(org_page);

  const { state, dispatch } = React.useContext(Context);
  const [lafId, setLafId] = React.useState(getParamsFromSessionStorage('laf_id'))
  const [lanId, setLanId] = React.useState('')
  const lenderId = location?.pathname?.split('/')[2]
  const [leadId, setLeadId] = React.useState(getParamsFromSessionStorage('lead_id'))
  const [applicationId, setApplicationId] = React.useState(getParamsFromSessionStorage('application_id'))
  const [tableData, setTableData] = React.useState([])
  const [pagination, setPagination] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false)
  const [expoetLoader, setExportLoader] = useState(false)
  const [assignDatefrom, setAssignDatefrom] = useState(getParamsFromSessionStorage('assigned_date_from', 'date'))
  const [assignDateto, setAssignDateto] = useState(getParamsFromSessionStorage('assigned_date_to', 'date'))
  const [createdDatefrom, setCreatedDatefrom] = useState(getParamsFromSessionStorage('created_date_from', 'date'))
  const [createdDateto, setCreatedDateto] = useState(getParamsFromSessionStorage('created_date_to', 'date'))
  const [isSubmitClick, setIsSubmitClick] = useState(false)
  const [applicationStatus, setApplicationStatus] = useState(getParamsFromSessionStorage('response_status'))
  const [clmType, setClmType] = useState(getParamsFromSessionStorage('lead_type'))
  const [losSource, setLosSource] = useState(getParamsFromSessionStorage('los_source'))
  const searchFilterRef = React.useRef()
  let payloadData = {};
  const [key, setKey] = React.useState('')

  React.useEffect(() => {
    if (lenderId !== searchData?.lender_id) {
      resetFilter()
    }
  }, [location?.pathname])
  React.useEffect(() => {
    getApiLogsList(false)
  }, [page])

  const handleSubmit = () => {
    getApiLogsList(true)
  }

  const getApiLogsList = async (paramsChanged, type) => {
    setIsLoading(true)
    payloadData = {
      type: state.userType,
      lender_id: lenderId,
      laf_id: type !== 'reset' ? lafId : '',
      los_source: type !== 'reset' ? losSource : '',
      response_status: type !== 'reset' ? applicationStatus : '',
      lead_type: 'reset' ? clmType : '',
      lead_id: type !== 'reset' ? leadId : '',
      application_id: type !== 'reset' ? applicationId : '',
      assigned_date_from: type !== 'reset' ? assignDatefrom ? getFormattedDate(assignDatefrom, 'dd/MM/yyyy') : '' : '',
      assigned_date_to: type !== 'reset' ? assignDateto ? getFormattedDate(assignDateto, 'dd/MM/yyyy') : '' : '',
      created_date_from: type !== 'reset' ? createdDatefrom ? getFormattedDate(createdDatefrom, 'dd/MM/yyyy') : '' : '',
      created_date_to: type !== 'reset' ? createdDateto ? getFormattedDate(createdDateto, 'dd/MM/yyyy') : '' : '',
      page: paramsChanged ? 1 : page,
      dataExport: 0
    }
    type !== 'reset' && sessionStorage.setItem('searchData', JSON.stringify({ ...payloadData, org_page: paramsChanged ? 1 : page }))
    let res = await LenderUgroService.getApiLogList(payloadData);
    let data = res?.data?.data?.log_list?.data
    data.map((item, index) => {
      item.index = index + 1
      item.action = <View item={item} />
    })
    setTableData(data)
    setCurrentPage(page);
    setPagination(res?.data?.data?.log_list?.pagination);
    setIsLoading(false)
  }


  const resetFilter = () => {
    sessionStorage.removeItem('searchData');
    setLafId('')
    // setLanId('')
    setLeadId('')
    setApplicationStatus('')
    setClmType('')
    setLosSource('')
    setApplicationId('')
    setAssignDatefrom('')
    setAssignDateto('')
    setCreatedDatefrom('')
    setCreatedDateto('')
    setTimeout(() => {
      getApiLogsList(false, 'reset')
    }, 500)
  }
  React.useEffect(() => {
    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        if (isOutside) {
          document.getElementById("submitButton").click();
        }
        event.preventDefault();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  React.useEffect(
    () => {
      const listener1 = (event) => {
        if (!searchFilterRef.current || searchFilterRef.current.contains(event.target)) {
          isOutside = true
          return;
        } else {
          isOutside = false
        }
      };
      document.addEventListener("mousedown", listener1);
      document.addEventListener("touchstart", listener1);
      return () => {
        document.removeEventListener("mousedown", listener1);
        document.removeEventListener("touchstart", listener1);
      };
    },
    [searchFilterRef, isOutside]
  );

  const exportLogs = async (flag) => {
    try {
      setExportLoader(true)
      let response = await LenderUgroService.exportApiLogList({
        type: state.userType,
        lender_id: lenderId,
        response_status: flag ? applicationStatus : '',
        laf_id: flag ? lafId : '',
        lead_type: flag ? clmType : '',
        lead_id: flag ? leadId : '',
        application_id: flag ? applicationId : '',
        assigned_date_from: assignDatefrom ? getFormattedDate(assignDatefrom, 'dd/MM/yyyy') : '',
        assigned_date_to: assignDateto ? getFormattedDate(assignDateto, 'dd/MM/yyyy') : '',
        created_date_from: createdDatefrom ? getFormattedDate(createdDatefrom, 'dd/MM/yyyy') : '',
        created_date_to: createdDateto ? getFormattedDate(createdDateto, 'dd/MM/yyyy') : '',
        page: page,
      })
      if (response?.status == 200) {
        downloadFile(response?.data, `${LenderNames[lenderId].replace(' ', '_')}_Application_Logs_${new Date()?.toISOString()?.split('T')[0]}`)
        setExportLoader(false)
      }
    } catch (error) {
      setExportLoader(false)
      console.log(error)
    }
  }
  return (
    <div class="mt-2" ref={searchFilterRef}>
      <div className="d-flex">
        <h2 className='heading mb-3'> {`${LenderNames[lenderId]}`} Api Logs</h2>
      </div>
      <div className="chart-card mb-3">
        <div className="row">
          <div className='col-md-4'>
            <div className='form-group'>
              <label>LAF/LAN ID</label>
              <input
                className='form-control inputField'
                value={lafId}
                onChange={(e) => setLafId(e.target.value)}
              />
            </div>
          </div>
          <div className='col-md-4'>
            <div className='form-group'>
              <label>Lead ID</label>
              <input
                className='form-control inputField'
                value={leadId}
                onChange={(e) => {
                  setLeadId(e.target.value)
                }}
              />
            </div>
          </div>
          <div className='col-md-4'>
            <div className='form-group'>
              <label>Application ID</label>
              <input
                className='form-control inputField'
                value={applicationId}
                onChange={(e) => {
                  setApplicationId(e.target.value)
                }}
              />
            </div>
          </div>
          <div className='col-md-2'>
            <div className='form-group'>
              <label>Application Status</label>
              <select className='form-control'
                onChange={(e) => setApplicationStatus(e.target.value)}
                value={applicationStatus}>
                <option value=''>Select Status</option>
                <option value='Rejected,L1Rejected'>Rejected</option>
                <option value='Sanctioned'>Sanctioned</option>
                <option value='Disbursed'>Disbursed</option>
              </select>
            </div>
          </div>
          <div className='col-md-2'>
            <div className='form-group'>
              <label>CLM Type</label>
              <select className='form-control'
                onChange={(e) => setClmType(e.target.value)}
                value={clmType}>
                <option value=''>Select Type</option>
                <option value='1'>Option 1</option>
                <option value='2'>Option 2</option>
              </select>
            </div>
          </div>
          {/* {<div className='col-md-4'>
            <div className='form-group'>
              <label>Lender Status Date</label>
              <div className='d-flex justify-content-between'>
                <div className='d-flex w-50 align-items-center'>
                  <span className='mr-2'>From</span>
                  <DatePicker
                    selected={assignDatefrom}
                    portalId='datepickerportal'
                    showMonthDropdown
                    yearDropdownItemNumber={100}
                    scrollableYearDropdown={true}
                    showYearDropdown
                    className='form-control'
                    dateFormat='dd/MM/yyyy'
                    onChange={(selectedDate) =>
                      setAssignDatefrom(selectedDate)
                    } //only when value has changed
                  />
                </div>

                <div className='d-flex w-50 align-items-center'>
                  <span className='ml-2 mr-2'>To</span>
                  <DatePicker
                    selected={assignDateto}
                    portalId='datepickerportal'
                    yearDropdownItemNumber={100}
                    scrollableYearDropdown={true}
                    showMonthDropdown
                    className='form-control'
                    dateFormat='dd/MM/yyyy'
                    onChange={(selectedDate) =>
                      setAssignDateto(selectedDate)
                    } //only when value has changed
                  />
                </div>
              </div>
            </div>
          </div>} */}
          {<div className='col-md-4'>
            <div className='form-group'>
              <label>Created At</label>
              <div className='d-flex justify-content-between'>
                <div className='d-flex w-50 align-items-center'>
                  <span className='mr-2'>From</span>
                  <DatePicker
                    selected={createdDatefrom}
                    portalId='datepickerportal'
                    showMonthDropdown
                    yearDropdownItemNumber={100}
                    scrollableYearDropdown={true}
                    showYearDropdown
                    className='form-control'
                    dateFormat='dd/MM/yyyy'
                    onChange={(selectedDate) =>
                      setCreatedDatefrom(selectedDate)
                    } //only when value has changed
                  />
                </div>

                <div className='d-flex w-50 align-items-center'>
                  <span className='ml-2 mr-2'>To</span>
                  <DatePicker
                    selected={createdDateto}
                    portalId='datepickerportal'
                    yearDropdownItemNumber={100}
                    scrollableYearDropdown={true}
                    showMonthDropdown
                    className='form-control'
                    dateFormat='dd/MM/yyyy'
                    onChange={(selectedDate) =>
                      setCreatedDateto(selectedDate)
                    } //only when value has changed
                  />
                </div>
              </div>
            </div>
          </div>}
          <div className='col-md-2'>
            <div className='form-group'>
              <label>LOS Source</label>
              <select className='form-control'
                onChange={(e) => setLosSource(e.target.value)}
                value={losSource}>
                <option value={''}>Select LOS Source</option>
								<option key={'dops'} value={'dops'}>{'dOps'}</option>
								<option key={'skaleup'} value={'skaleup'}>{'SkaleUp'}</option>
              </select>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12 d-flex'>
            <button
              onClick={() => handleSubmit(1)}
              type='button'
              disabled={isLoading}
              className='btn btn-custom viewBtn mr-1'
              id='submitButton'
            >
              {!isLoading ? 'Search' : <div className="loader"></div>}
            </button>
            <button
              onClick={resetFilter}
              type='button'
              className='btn btn-custom viewBtn'
            >
              Reset All
            </button>
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-end'>
        <Button
          type='btn-export'
          classNames='float-right text-white mt-2 mb-2'
          clickHandler={exportLogs}
        >
          <i class="fa fa-file-excel-o mr-1" aria-hidden="true"></i>
          {!expoetLoader ? 'Export Excel' : <div className="loader"></div>}
        </Button>
      </div>
      <div className={lenderId == 4 ? 'bob_api_logs_table' : 'api_logs_table'}>
        <Table
          columns={lenderId == 4 ? columnsForBOB : tableColumns}
          // checkbox={true}
          // customCheck={showCheckbox}
          rows={tableData}
          // headerChecked={tableHeaderChecked}
          // headerCheckboxUpdateCallback={tableHeaderCheckboxUpdateCallback}
          // rowCheckboxUpdateCallback={tableRowCheckboxUpdateCallback}
          loading={isLoading}
        // reloadTable={redirectToAdditional}
        // onSortChange={onSortChange}
        // type='unassigned'
        >
          {Boolean(!tableData.length && !isLoading) && <TableNoRecords />}
        </Table>
      </div>

      <div className='mt-2' key={key}>
        {pagination?.total_pages ? (
          <Pagination
            // disabled={loading}
            setPage={setCurrentPage}
            total_pages={pagination.total_pages}
            total={pagination.total}
            showTotal={true}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  )
}

export default ApiListing